import script from "./user-header.vue?vue&type=script&lang=ts&setup=true"
export * from "./user-header.vue?vue&type=script&lang=ts&setup=true"

import "./user-header.vue?vue&type=style&index=0&id=53e377a3&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53e377a3"]])

export default __exports__